import { render, staticRenderFns } from "./TodoEvent.vue?vue&type=template&id=4c0729a2&"
import script from "./TodoEvent.vue?vue&type=script&lang=js&"
export * from "./TodoEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports